import { type AnyElement } from "@zyzgroup/core-common";
import { Observable } from "rxjs";

// 跟踪元素的位置变化，如果 被观察元素 占 父元素 的 threshold 不变，则不会触发
export function useIntersection$(
  el: AnyElement,
  options: IntersectionObserverInit = {
    root: null // default browser viewport 必须是目标元素的父级元素
    // threshold: 0.5, // 表示重叠面积占被观察者的比例，从 0 - 1 取值，1 表示完全被包含
  }
): Observable<IntersectionObserverEntry> {
  return new Observable((observer) => {
    const io = new IntersectionObserver(
      (entries: IntersectionObserverEntry[], _: IntersectionObserver) => {
        // entry.time; // 触发的时间
        // entry.rootBounds; // 视窗位置矩形
        // entry.boundingClientRect; // 被观察者的位置矩形
        // entry.intersectionRect; // 重叠区域的位置矩形
        // entry.intersectionRatio; // 重叠区域占被观察者面积的比例（被观察者不是矩形时也按照矩形计算）
        // entry.target; // 被观察者
        if (entries.length) {
          // const entry = entries.find(
          //   // browsers can report isIntersecting as true, but intersectionRatio as 0, when something very slowly enters the viewport
          //   (e, i) => e.isIntersecting
          //   // &&
          //   // e.intersectionRatio >=
          //   //   (options?.threshold
          //   //     ? typeof options.threshold == "number"
          //   //       ? options.threshold
          //   //       : options.threshold[i]
          //   //     : 0.5)
          // );
          const entry = entries[entries.length - 1];
          if (entry) {
            observer.next(entry);
          }
        }
      },
      options
    );
    io.observe(el);
    return () => {
      io.unobserve(el);
      io.disconnect();
    };
  });
}
